module.exports = __webpack_public_path__ + "static/img/10.9f25a54.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/10.png
// module id = z16J
// module chunks = 0